// Copyright (c) Move Closer 2022.

import gql from 'graphql-tag'

import { MagentoVersion, QueryRegistry, QueryRegistryFactory } from '../../../contexts'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const reviewsQueries: QueryRegistryFactory = (config) => {
  const version = config.byKey<MagentoVersion>('magentoVersion', false) ?? MagentoVersion.Default

  let queries: QueryRegistry = {
    createReview: {
      type: 'mutation',
      query: gql`
        mutation(
          $sku: String!,
          $author: String!,
          $summary: String!,
          $content: String!,
          $ratingConfigId: String!,
          $ratingConfigValue: String!
        ) {
          createProductReview(
            input: {
              sku: $sku,
              nickname: $author,
              summary: $summary,
              text: $content,
              ratings: [
                {
                  id: $ratingConfigId,
                  value_id: $ratingConfigValue
                }
              ]
            }
          ) {
            review {
              nickname
              summary
              text
              average_rating
              ratings_breakdown {
                name
                value
              }
            }
          }
        }
      `,
      meta: {}
    },
    reviewsMetadataQuery: {
      type: 'query',
      query: gql`
        query {
          productReviewRatingsMetadata {
            items {
              id
              name
              values {
                value_id
                value
              }
            }
          }
        }
      `,
      meta: {}
    }
  }

  if (version === MagentoVersion.Default) {
    queries = {
      ...queries,
      reviewsQuery: {
        type: 'query',
        query: gql`
          query($skus: [String]!) {
            productReviews(sku: $skus) {
              items {
                author
                content,
                createdAt,
                isVerified,
                owner,
                rate
              }
            }
          }
        `,
        meta: {}
      }
    }
  }

  return queries
}
